<template>
    <div>
        <div class="row">
            <div class="col-12 text-center">
                <b-iconstack font-scale="9">
                    <b-icon stacked icon="shield" variant="primary"></b-icon>
                    <b-icon stacked icon="person" variant="secondary" scale="0.4" shift-v="1"></b-icon>
                </b-iconstack>
            </div>
        </div>
        <div class="row">
            <div class="col-12 text-center">
                <div class="p-5">
                    <h2 class="mb-5">Mantengamos contacto</h2>
                    <div class="body-text">Si aún no necesitas agendar una cita no te preocupes, podrás hacerlo cuando lo requieras, mientras te invitamos a que consultes por otros servicios de tu interés en nuestro sitio web.</div>
                </div>
            </div>
        </div>
        <div class="row form-group">
            <div class="col-12 text-center">
                <button class="btn btn-primary btn-large" @click="gotToSite">
                    Ir al sitio web
                    <b-icon icon="box-arrow-up-right"></b-icon>
                </button>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    methods: {
        gotToSite: function() {
            window.location = 'https://www.bnb.com.bo/PortalBNB/ValoresBNB/Index/600';
        }
    }
}
</script>

<style lang="scss" scoped>
    @import "../bnbVariables.scss";

    .body-text {
        font-size: 1.2rem;
    }

    .like {
        animation: likeFadeIn 1.5s ease-in-out;

        path {
            fill: $primary;
        }
    }
    @keyframes likeFadeIn {
          0% { transform: scale(0); }
         10% { transform: scale(0); }
         50% { transform: scale(1.1); }
         55% { transform: scale(0.9); }
         60% { transform: scale(1); }
         70% { transform: rotate(0deg); }
         75% { transform: rotate(-10deg); }
         85% { transform: rotate(10deg); }
         95% { transform: rotate(-5deg); }
         98% { transform: rotate(2deg); }
        100% { transform: rotate(0deg); }
    }

    h2 {
        font-size: 2.2rem;
        color: $secondary;
    }

    h3, h4, h5 {
        font-size: 1.2rem;
        font-weight: normal;
    }

    h3 {
        color: $primary;
    }

    h4 {
        color: $secondary;
    }

    h5 {
        color: #333;
    }

    .disclaimer {
        font-size: .8rem;
    }

    .number-of-dependents-container {
        width: 150px;
    }

    .input-group-append button {
        border-radius: 0px 10px 10px 0px;
    }

    .input-group-prepend button {
        border-radius: 10px 0px 0px 10px;
    }

    .number-of-dependents-container input {
        border-color: $secondary !important;
        text-align: center;
    }
</style>
